export default __webpack_public_path__ + "static/media/Raed_Altaki_Resume_Senior_Backend_Engineer.6d032b05.pdf";